import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsTagsCreateRoute extends Route {
  @service declare store: any;

  model() {
    return this.store.createRecord('theme', {});
  }
}

export default instrumentRoutePerformance(SettingsTagsCreateRoute);
